module.exports = __webpack_public_path__ + "../resources/img/bg_storage2_03.fd241a20.png";